import { render, staticRenderFns } from "./DesignSummary.vue?vue&type=template&id=1c2370a3&scoped=true&"
import script from "./DesignSummary.vue?vue&type=script&lang=js&"
export * from "./DesignSummary.vue?vue&type=script&lang=js&"
import style0 from "./DesignSummary.vue?vue&type=style&index=0&id=1c2370a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2370a3",
  null
  
)

export default component.exports